import * as React from "react";
import { cx } from "utils/join-classnames";
import styles from "./Toast.module.scss";

type Props = {
    children: React.ReactNode;
    className?: string;
};

const ToastContainer: React.FC<Props> = ({ children, className }) => (
    <div className={cx(styles.container, className)}>
        {React.Children.toArray(children).reverse()}
    </div>
);

export default ToastContainer;
